import { ginzaxiaomaApiRequest } from 'apis';
import {
  PmsProductBoxCategoryOption,
  PmsProductBoxRecord,
  PmsProductBoxSaveDto,
} from 'types/pms-product-box';

export const productBoxList = (data: {
  pageNum: number;
  pageSize: number;
  name?: string;
  productCategoryId?: number;
}) => {
  return ginzaxiaomaApiRequest.post<{
    list: PmsProductBoxRecord[];
    total: number;
  }>('/admin/pms/product-box/list', data);
};

export const productBoxDetail = (id: number) => {
  return ginzaxiaomaApiRequest.get<PmsProductBoxRecord>(
    `/admin/pms/product-box/${id}`,
  );
};

export const productBoxCreate = (data: PmsProductBoxSaveDto) => {
  return ginzaxiaomaApiRequest.post<PmsProductBoxRecord>(
    '/admin/pms/product-box/create',
    data,
  );
};

export const productBoxUpdate = (id: number, data: PmsProductBoxSaveDto) => {
  return ginzaxiaomaApiRequest.post<PmsProductBoxRecord>(
    `/admin/pms/product-box/update/${id}`,
    data,
  );
};

export const productBoxDelete = (id: number) => {
  return ginzaxiaomaApiRequest.post<{ id: number }>(
    `/admin/pms/product-box/delete/${id}`,
  );
};

export type PmsProductBoxOption = {
  id: number;
  name: string;
  nameZh: string;
  nameJa: string;
  displayName: string;
  lengthCm: number;
  widthCm: number;
  heightCm: number;
};

export const productBoxOptions = () => {
  return ginzaxiaomaApiRequest.get<PmsProductBoxOption[]>(
    '/admin/pms/product-box/options',
  );
};

export const productBoxByCategory = (categoryId: number) => {
  return ginzaxiaomaApiRequest.get<PmsProductBoxOption | null>(
    `/admin/pms/product-box/by-category/${categoryId}`,
  );
};

export const productBoxCategoryOptions = (excludeBoxId?: number) => {
  return ginzaxiaomaApiRequest.get<PmsProductBoxCategoryOption[]>(
    '/admin/pms/product-box/category-options',
    { params: excludeBoxId ? { excludeBoxId } : undefined },
  );
};
